
import { Vue } from 'vue-class-component';

export default class HomeArea extends Vue {}
